import Title from '@/components/Title';
import React, { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';
import LeadButton from '@/components/LeadButton';
import useIsMobileNew from '@/hooks/useIsMobileNew';
import useIsMediumScreen from '@/hooks/useIsMediumScreen';
import useIsMaxScreen from '@/hooks/useIsMaxScreen';
import Image from 'next/image';

const Awards = () => {
  const { t, i18n } = useTranslation(['home', 'math']);
  const isSmallScreen = useIsMobileNew();
  const isMediumScreen = useIsMediumScreen();
  const isMaxScreen = useIsMaxScreen();

  const memorizedLevelImgUrl = useMemo(() => {
    if (isMaxScreen || isMediumScreen) {
      if (i18n?.language === 'zh') {
        return '/images/math/level-data-bg-cn.png';
      }
      return '/images/math/level-data-bg-en.png';
    }
    if (isSmallScreen) {
      if (i18n?.language === 'zh') {
        return '/images/math/level-data-bg-cn-m.png';
      }
      return '/images/math/level-data-bg-en-m.png';
    }
    return '';
  }, [isMaxScreen, isMediumScreen, isSmallScreen, i18n?.language]);

  const memorizedRaceImgUrl = useMemo(() => {
    if (isMaxScreen || isMediumScreen) {
      if (i18n?.language === 'zh') {
        return '/images/math/race-bg-cn.png';
      }
      return '/images/math/race-bg-en.png';
    }
    if (isSmallScreen) {
      if (i18n?.language === 'zh') {
        return '/images/math/race-bg-cn-m.png';
      }
      return '/images/math/race-bg-en-m.png';
    }
    return '';
  }, [isMaxScreen, isMediumScreen, isSmallScreen, i18n?.language]);

  return (
    <div className="container relative lg:mb-[140px] lg:mt-[140px] xl:mb-[200px] xl:mt-[200px]">
      <Title theme="math" innerHTML>
        {t('math:奖项标题')}
      </Title>
      <p
        className={cls(
          'm-auto mb-[24px] mt-[24px] text-center text-[16px] leading-[24px] text-[#1B1F4D] lg:w-[984px] xl:w-[1160px] xl:text-[20px]',
          i18n?.language === 'zh' ? 'lg-leading-[28px] xl:leading-[32px]' : '',
        )}
      >
        {t('math:奖项副标题')}
      </p>
      <div
        className={cls(
          'm-auto flex rounded-[24px] bg-[length:100%_100%] shadow-[0_7.969px_19.922px_0_rgba(0,0,0,0.04)] lg:mt-[26px] lg:h-[450px] lg:w-[850px] lg:rounded-[38px] xl:mt-[40px] xl:w-[1280px] xl:rounded-[38px]',
          i18n?.language === 'zh' ? 'h-[209px]   xl:h-[667px] ' : 'h-[230px]   xl:h-[772px] ',
        )}
      >
        <Image
          className="h-auto w-full"
          height={0}
          width={0}
          sizes="100vw"
          alt={i18n?.language === 'zh' ? '悟空国际数学-培优系统课' : 'WuKong Math - Main Courses'}
          src={memorizedLevelImgUrl}
        />
      </div>
      <div
        className={cls(
          'm-auto mt-[10px] flex rounded-[24px] bg-[length:100%_100%] shadow-[0_7.969px_19.922px_0_rgba(0,0,0,0.04)] lg:h-[288px] lg:w-[850px] lg:rounded-[38px] xl:mt-[40px] xl:w-[1280px] xl:rounded-[38px]',
          i18n?.language === 'zh' ? 'h-[126px] xl:h-[423px] ' : 'h-[157px] xl:h-[443px]',
        )}
      >
        <Image
          className="h-auto w-full"
          height={0}
          width={0}
          sizes="100vw"
          alt={i18n?.language === 'zh' ? '悟空国际数学-培优系统课' : 'WuKong Math - Main Courses'}
          src={memorizedRaceImgUrl}
        />
      </div>
      <div className="text-center">
        <LeadButton
          subject="math"
          theme="math"
          size="xl"
          className="mt-[24px] lg:mt-[67px] xl:mt-[60px]"
          traceName="O_MathCourse_CurriculumSystem_CTAClick"
          traceGa4Name="new_entry_MathCourse_CurriculumSystemCTA"
        >
          {t('math:math-按钮')}
        </LeadButton>
      </div>
    </div>
  );
};

export default Awards;
